import { Spinner } from "react-bootstrap";

export function CenteredSpinner({ isLoading }: {
  isLoading: boolean;
})
{
  if(isLoading) {
    return (
      <div className="d-flex justify-content-center w-full">
        <Spinner/>
      </div>
    )
  }
  return <></>
}